// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "raw": "v0.3.4-prev-rc2-0-g8523903",
    "hash": "g8523903",
    "distance": 0,
    "tag": "v0.3.4-prev-rc2",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v0.3.4-prev-rc2",
        "major": 0,
        "minor": 3,
        "patch": 4,
        "prerelease": [
            "prev-rc2"
        ],
        "build": [],
        "version": "0.3.4-prev-rc2"
    },
    "suffix": "0-g8523903",
    "semverString": "0.3.4-prev-rc2",
    "version": "0.0.0"
};
/* tslint:enable */
